import Vue from 'vue'
import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'
import App from './App'
import store from './store'
import './assets/style.css'
import './assets/desktop.css'
import router from './router'
import 'babel-polyfill'
import {
  Vuetify,
  VApp,
  VProgressCircular
} from 'vuetify'
import VueMultianalytics from 'vue-multianalytics'
import VModal from 'vue-js-modal'

const bugsnag = require('bugsnag-js')
const bugsnagClient = bugsnag('5cfd4315e0e7bf47317160c7375a4b8a')
const bugsnagVue = require('bugsnag-vue')
bugsnagClient.use(bugsnagVue(Vue))


let mixpanelConfig = {
  token: '2e37a08871b02a5135e9f30e1118a4c1'
}
Vue.use(VueMultianalytics, {
  modules: {
    mixpanel: mixpanelConfig
  },
  routing: {
    vueRouter: router
  }
})

Vue.use(Vuetify, {
  components: {
    VApp,
    VProgressCircular
  }
})
Vue.use(VueLodash, lodash)
Vue.use(VModal)

/* eslint-disable no-unused-vars */
var vm = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js